module.exports = __webpack_public_path__ + "img/icon-choose.1387e440.png";